<template>
  <span
      class="ai-visibility-status-pill"
      :class="[
      `ai-visibility-status-pill--${tone}`,
      { 'ai-visibility-status-pill--dot': dot },
    ]"
  >
    <i v-if="showArrow" class="material-icons">{{iconName}}</i>
    <span>{{ label }}</span>
  </span>
</template>

<script>
export default {
  name: 'StatusPill',
  props: {
    tone: {
      type: String,
      default: 'neutral',
    },
    label: {
      type: String,
      required: true,
    },
    dot: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      if (this.tone === 'success') return 'arrow_upward';
      if (this.tone === 'danger') return 'arrow_downward';
      return '';
    }
  }

}
</script>

<style lang="scss" scoped>

.ai-visibility-status-pill {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 999px;
  background: var(--v-gray10Color-base);
  color: var(--v-gray50Color-base);
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.12px;
  line-height: 1;
  padding: 4px 10px;
}

.ai-visibility-status-pill--dot::before {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
  content: '';
}

.ai-visibility-status-pill--success {
  background: var(--v-green10Color-base);
  color: var(--v-green8Color-base);
}

.ai-visibility-status-pill--danger {
  background: var(--v-red6Color-base);
  color: var(--v-red11Color-base);
}

.ai-visibility-status-pill--info {
  background: var(--v-link9Color-base);
  color: var(--v-link4Color-base);
}

</style>
